import { call, put, take, takeLatest } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { OVERLAY_SPINNER, OVERLAY_TEXT } from "../../constants/overlayTypes";
import { putError, putSuccess } from "../helpers";


function* overlaySetOverlayType(overlayType) {
    yield put({type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE, payload: {overlayType: overlayType}})
}

function* overlaySetRequestType(requestType) {
    yield put({type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE, payload: { requestType: requestType }})
}

function* createNewspaper(action) {
    try {
        yield call(overlaySetRequestType, actionTypes.PRINT_DATA_NEWSPAPER_PDF_REQUEST)
        yield call(overlaySetOverlayType, OVERLAY_SPINNER)

        yield put({type: actionTypes.PRINT_DATA_UPDATE_REQUEST})

        const update = yield take([
            actionTypes.PRINT_DATA_UPDATE_SUCCESS, 
            actionTypes.PRINT_DATA_UPDATE_ERROR
        ])

        if(actionTypes.PRINT_DATA_UPDATE_SUCCESS === update.type) {
            yield put({
                type: actionTypes.POST_POSTER_PDF_COMBINED_REQUEST,
                meta: {},
                payload: action.payload
            })

            const pdf = yield take([actionTypes.POST_POSTER_PDF_COMBINED_SUCCESS, actionTypes.POST_POSTER_PDF_COMBINED_ERROR])

            if(actionTypes.POST_POSTER_PDF_COMBINED_SUCCESS === pdf.type ) {
                yield putSuccess(actionTypes.PRINT_DATA_NEWSPAPER_PDF_SUCCESS)
                yield call(overlaySetOverlayType, OVERLAY_TEXT)
            } else {
                throw new Error('Could not create pdf')
            }
        } else {
            throw new Error('Could not update data')
        }

        
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.PRINT_DATA_NEWSPAPER_PDF_ERROR, e.message)
        yield call(overlaySetOverlayType, OVERLAY_TEXT)
    }
}

function* watchPdfNewspaperRequest() {
    yield takeLatest(actionTypes.PRINT_DATA_NEWSPAPER_PDF_REQUEST, createNewspaper)
}

export default watchPdfNewspaperRequest